export default {
  storefront_not_found: {
    title: 'Ingen butik fundet',
    description: 'Opret en butik.',
  },
};
